import React from 'react';
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { SwapHorizRounded } from "@mui/icons-material";
import { toPriceWithComma } from "../../../helper/utils";
import { ProcessTypeEnum } from "../../../helper/enums/ProcessTypeEnum";

const _CreditTransactionsList = ({ loading, transactions }) => {
    return (
        <Box
            sx={{
                p: 2,
                pt: 1,
                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.15)' : 'rgba(0, 0, 0, 0.02)',
                borderTop: '1px dashed',
                borderColor: 'divider',
            }}
        >
            <Typography variant="caption" sx={{ fontWeight: 800, color: 'text.secondary', display: 'block', mb: 1.5 }}>
                ریز تراکنش‌های این بسته اعتباری:
            </Typography>

            {loading ? (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 2, gap: 1 }}>
                    <CircularProgress size={18} color="primary" />
                    <Typography variant="caption" color="text.secondary">
                        در حال دریافت گزارش تراکنش‌ها...
                    </Typography>
                </Box>
            ) : transactions.length > 0 ? (
                <Stack spacing={1}>
                    {transactions.map((tx) => (
                        <Box
                            key={tx.Id}
                            sx={{
                                p: 1.2,
                                px: 1.5,
                                borderRadius: 2,
                                bgcolor: 'background.paper',
                                border: '1px solid',
                                borderColor: 'divider',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <SwapHorizRounded fontSize="small" color="action" />
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                    {tx.Description || ProcessTypeEnum[tx.ProcessType] || "تراکنش مصرفی"}
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: 800,
                                        color: tx.Amount < 0 ? 'error.main' : 'success.main',
                                        dir: 'ltr',
                                    }}
                                >
                                    {toPriceWithComma(tx.Amount)} تومان
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {new Date(tx.CreatedDate).toLocaleDateString('fa-IR', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric',
                                    })}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Stack>
            ) : (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', py: 1, textAlign: 'center' }}>
                    هیچ تراکنشی روی این بسته اعتباری ثبت نشده است.
                </Typography>
            )}
        </Box>
    );
};

export default _CreditTransactionsList;
